import { TaskFormObject } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import { Dropdown, Menu, Switch } from "antd"
import { useFormikContext } from "formik"
import { SidebarButton } from "../sidebar-button"
import { useEffect, useRef, useState } from "react"
import { DollarCircleOutlined } from "@ant-design/icons"
import { COLORS } from "components/layout-components/timenotes-theme"
import OutsideAlerter from "components/view-utils/outside-alerter"
import styled from "styled-components"
import { RestrictedIcon } from "components/base/restricted-icon"

interface Props extends React.ComponentProps<typeof Switch>{}

export const TaskBillableSwitch = (props: Props) => {

  const itemRef = useRef()

  const [visible, setVisible] = useState(false)

  const formik = useFormikContext<TaskFormObject>()
  const task = formik.values

  const isBillable = task.isBillable
  const defaultProjectBillable = task.project?.defaultIsBillableTimeLogs

  let selectedKey: string = ""

  if (isBillable === null) {
    selectedKey = 'default'
  } else {
    selectedKey = isBillable ? 'billable' : 'non-billable'
  }

  useEffect(() => {
    if (visible) {
      itemRef.current?.focus()
    }
  }, [visible])

  const menu = (
    <Menu
      selectedKeys={[selectedKey]}
      onClick={(item) => {
        const newValue = {
          'billable': true,
          'non-billable': false,
          'default': null,
        }[item.key]

        formik.setFieldValue('isBillable', newValue)
        formik.submitForm()

        setVisible(false)
      }}
      getPopupContainer={(el) => el}
      style={{
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
      }}

      onKeyDownCapture={(e) => {
        if (e.key == "Escape") {
          e.preventDefault()
          e.stopPropagation()

          setVisible(false)
        }
      }}

   >
      <div ref={itemRef} tabIndex={-1} />
      <MenuItem
        key="billable"
      >

        <DollarIcon billable={true} />
        Billable
      </MenuItem>

      <MenuItem
        key="non-billable"
      >
        <DollarIcon billable={false} />
        Non billable
      </MenuItem>

      <MenuItem
        key="default"
      >
        Use project default - {defaultProjectBillable ? 'billable' : 'non billable'}
      </MenuItem>
    </Menu>
  )

  return (
    <>
      <OutsideAlerter
        onClick={() => setVisible(false)}
      >
        <Dropdown
          visible={visible}
          overlay={menu}
          getPopupContainer={(el) => el}
        >
          <div
            onClick={() => setVisible((v) => !v)}
          >
            <SidebarButton>
              Billable Default
            </SidebarButton>
          </div>
        </Dropdown>
      </OutsideAlerter>

      <div
        style={{
          marginLeft: '8px',
          cursor: 'pointer',
        }}
        onClick={() => setVisible(true)}

      >
        { isBillable === true && (
          <BillableLabel>
            <DollarIcon billable={true} />
            Billable
          </BillableLabel>
        )} 

        { isBillable === false && (
          <BillableLabel>
            <DollarIcon billable={false} />
            Non billable 
          </BillableLabel>
        )} 

        { isBillable === null && (
          <BillableLabel>
            Project default - {defaultProjectBillable ? 'billable' : 'non billable'}
          </BillableLabel>
        )} 

      </div>
    </>
  )
}

interface DollarIconProps {
  billable: boolean
}

const DollarIcon = (props: DollarIconProps) => {
  const {
    billable,
  } = props

  return (
    <DollarCircleOutlined 
      style={{ 
        fontSize: '18px',
        color: billable ? COLORS.primaryGreen : undefined
      }}
    />
  )
}

interface MenuItemProps extends React.ComponentProps<typeof Menu.Item> {
}

const BillableLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`
const MenuItem = (props: MenuItemProps) => {
  const {
    ...menuProps
  } = props

  return (
    <Menu.Item
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
      {...menuProps}
    />
  )
}